{
  "version": 2,
  "name": "San Juan Islands",
  "displayInfo": {
    "description": "A sprawling archipelago between Washington and Vancouver Island. Strong tidal currents, narrow passes, and plenty of ports to explore.",
    "difficulty": "expert"
  },
  "region": {
    "datasetPath": "wash_bellingham/",
    "bbox": {
      "minLat": 48.4,
      "minLon": -123.35,
      "maxLat": 48.75,
      "maxLon": -122.75
    },
    "interval": [
      [-300, 50],
      [-50, 10],
      [0, 5],
      [25, 25]
    ],
    "simplify": [
      [-300, 20],
      [-25, 5],
      [0, 1],
      [50, 10]
    ],
    "scale": 1,
    "minPerimeter": 3000,
    "minPoints": 4,
    "flipY": true
  },
  "waves": {
    "sources": [
      {
        "amplitude": 0.7,
        "wavelength": 60,
        "direction": 0.79,
        "phaseOffset": 0.0
      },
      {
        "amplitude": 0.22,
        "wavelength": 18,
        "direction": 0.85,
        "phaseOffset": 1.62
      },
      {
        "amplitude": 0.4,
        "wavelength": 380,
        "direction": -0.39,
        "phaseOffset": 3.24
      },
      {
        "amplitude": 0.15,
        "wavelength": 640,
        "direction": 0.02,
        "phaseOffset": 4.85
      },
      {
        "amplitude": 0.3,
        "wavelength": 38,
        "direction": -0.75,
        "phaseOffset": 0.19
      },
      {
        "amplitude": 0.08,
        "wavelength": 7,
        "direction": 0.8,
        "phaseOffset": 1.81
      }
    ]
  },
  "wind": {
    "sources": [
      {
        "direction": 0.6
      }
    ]
  },
  "startPosition": [0, 0],
  "biome": {
    "zones": [
      {
        "maxHeight": 3,
        "color": [0.55, 0.52, 0.45],
        "colorAlt": [0.48, 0.45, 0.4],
        "noiseBlend": 0.3,
        "treeDensity": 0
      },
      {
        "maxHeight": 25,
        "color": [0.22, 0.3, 0.14],
        "colorAlt": [0.18, 0.22, 0.1],
        "noiseBlend": 0.5,
        "treeDensity": 0.6
      },
      {
        "maxHeight": 120,
        "color": [0.1, 0.2, 0.07],
        "colorAlt": [0.14, 0.16, 0.06],
        "noiseBlend": 0.5,
        "treeDensity": 0.85
      },
      {
        "maxHeight": 300,
        "color": [0.08, 0.16, 0.05],
        "colorAlt": [0.12, 0.12, 0.05],
        "noiseBlend": 0.4,
        "treeDensity": 0.8
      },
      {
        "maxHeight": 600,
        "color": [0.38, 0.42, 0.36],
        "colorAlt": [0.42, 0.4, 0.35],
        "noiseBlend": 0.3,
        "treeDensity": 0.3
      },
      {
        "maxHeight": 9999,
        "color": [0.52, 0.52, 0.5],
        "colorAlt": [0.48, 0.48, 0.45],
        "noiseBlend": 0.2,
        "treeDensity": 0
      }
    ],
    "rockColor": [0.42, 0.42, 0.4],
    "rockThreshold": 0.55,
    "snowlineHeight": -1,
    "largeNoiseScale": 0.004,
    "smallNoiseScale": 0.25
  },
  "trees": {
    "spacing": 35,
    "density": 0.75,
    "minElevation": 4,
    "maxElevation": 500
  }
}
